<template>
  <div>
    <v-card id="card-page-type">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              Selecione a fonte dos projetos:
              <b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorProjects">
              {{ requiredErrorProjectsText }}
            </v-sheet>
          </v-col>

          <v-col cols="8">
            <v-radio-group v-model="sourceOfProjects">
              <v-row>
                <v-col cols="4">
                  <v-radio label="Edital" value="OPPORTUNITY"></v-radio>
                </v-col>
                <v-col cols="4">
                  <v-radio label="Monitoramento" value="MONITOR"></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-card id="card-page-type">
      <v-container>
        <v-row class="nonothing">
          <v-col cols="4">
            <h3>
              {{ sourceField.name }}
              <b class="requiredfield">*</b>
            </h3>

            <v-sheet class="red--text" v-if="requiredErrorContest">
              {{ requiredErrorContestText }}
            </v-sheet>
          </v-col>

          <v-col cols="8">
            <v-select
              v-model="selectedContestId"
              item-text="name"
              item-value="id"
              :items="projectSources"
              :label="sourceField.label"
            ></v-select>
          </v-col>
          <!-- END FIELDS -->
        </v-row>
      </v-container>
    </v-card>

    <ManageProjects ref="projectManager" :source="sourceOfProjects" :tags="projectTags"/>
    <v-sheet v-show="projectListError" v-bind="projectListError" color="red--text">
      {{ projectListError }}
    </v-sheet>
  </div>
</template>


<script>
import ManageProjects from "@/components/form/formField/project/ManageProjectsFormField";
import { mapState, mapActions } from 'vuex';

export default {
  name: "FormPollProject",
  components: {
    ManageProjects
  },
  props: [ 'poll' ],
  data: () => ({
    // ----- FormValidation auxiliar vars
    hasErrors: false,
    requiredErrorProjects: false,
    requiredErrorContest: false,
    requiredErrorProjectsText: '',
    requiredErrorContestText: '',
    projectListError: null,
    // ----- END FormValidation auxiliar vars
    selectedProjects: [],
  }),
  computed: {
    ...mapState([ 'projectSources' ]),
    projectTags: function() {
      if( !this.selectedContestId ) return undefined;
      if( !this.projectSources || this.projectSources.length === 0 ) return undefined;

      const projectSourceObj = this.projectSources.filter( source => source.id === this.selectedContestId )
      if( !projectSourceObj || projectSourceObj.length === 0 )
        return undefined;
      return projectSourceObj[0].tags ? projectSourceObj[0].tags : null;
    },
    sourceField: function() {
      if( !this.sourceOfProjects )
        return { name: 'Selecione a fonte dos projetos primeiro', label: '' };
      if( this.sourceOfProjects === 'OPPORTUNITY' )
        return { name: 'Selecione seu Edital para escolha dos projetos', label: 'Selecione o edital' }
      return { name: 'Selecione seu Monitoramento para escolha dos projetos', label: 'Selecione o monitoramento' }
    },
    sourceOfProjects: {
      get() { return this.poll.project.sourceOfProjects },
      set(sourceType) { this.$store.dispatch( 'updateSourceOfProjects', {sourceType: sourceType} ) }
    },
    selectedContestId: {
      get() { return this.poll.project.selectedContestId },
      set(projectSourceId) {
        this.$store.dispatch( 'updateSelectedContestId', {
          sourceType: this.sourceOfProjects,
          sourceId: projectSourceId,
          // filters:  -  Must return all projects of that source, cause source just changed
            // TODO: A example of getting filters from table child
            // pageIndex: this.$refs.unselectedProjectsTable.getPageIndex()
            // offset: this.$refs.unselectedProjectsTable.getPageOffset()
            // actualPage: this.$refs.unselectedProjectsTable.getCurrentPage()
            // name: this.$refs.unselectedProjectsTable.getEntrepreneurName()
            // tags: this.$refs.unselectedProjectsTable.getTags()
            // status: this.$refs.unselectedProjectsTable.getStatus()
        });
      }
    },
    listOfSelectedProjects: function() { return this.poll.project.listOfSelectedProjects }
  },
  methods: {
    ...mapActions( ['updateSourceOfProjects', 'updateSelectedContestId'] ),
    isFormValid() {
      this.validateFormProject()
      return !this.hasErrors
    },
    validateFormProject(){
      this.requiredSourceOfProjects()
      this.requiredContest()
      this.minimumProjectList()
    },
    requiredSourceOfProjects() {
      if( !this.sourceOfProjects ) {
        this.requiredErrorProjects = true
        this.hasErrors = true
        this.requiredErrorProjectsText = "Selecione uma opção!"
      } else {
        this.requiredErrorProjects = false
      }
    },
    requiredContest() {
      if( !this.selectedContestId ) {
        this.requiredErrorContest = true
        this.hasErrors = true
        this.requiredErrorContestText = "Selecione uma opção!"
      } else {
        this.requiredErrorContest = false
      }
    },
    minimumProjectList() {
      if( this.listOfSelectedProjects.length < 2 ){
        this.projectListError = "Devem ser selecionados pelo menos dois itens da lista de projetos!"
        this.hasErrors = true;
      } else {
        this.projectListError = null;
        this.hasErrors = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.nonothing {
  margin: 0 !important;
  padding: 0 !important;
}

// FORMSPAGE
#card-page-type {
  background: #fcfcfc !important;
  border: thin solid #d3d3d3;
  border-left: 3px solid #2d9fab;
  box-shadow: none !important;
  margin: 0 0 24px !important;
  padding: 8px !important;
  display: grid;
  border-radius: 0 !important;

  h3 {
    color: #242424;
    font-family: 'Source Sans Pro', sans-serif;
    margin: 0 0 10px;
    font-size: 18px;
    line-height: 22px;
    font-weight: normal;
    opacity: 0.9;

    .requiredfield {
      color: #2e9fac;
      font-size: 22px;
      line-height: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/poll/FormPollProject.vue